export const getQueryParams = (search, key) => {
  if (typeof URLSearchParams === 'function') {
    return new URLSearchParams(search).get(key)
  }
}

export const createCaptchaImg = (uvi) => {
  return '/api/captcha?uvi=' + uvi + '&_t=' + Date.now() 
}